import ServiceApi from "../ServiceApi";
class TwitchDropsServiceApi extends ServiceApi {
  constructor() {
    super("twitchDropsService", "twitchDrops");
  }
  /**
   * Get user status from Twtitch
   *
   */
  getUser() {
    return this.request("getUser");
  }
}
export default new TwitchDropsServiceApi();
